import React from "react";
import NavLinkWrapper from "./components/NavLinkWrapper";
import FlexSection from "@/partials/sections/Section/FlexSection";
import ActiveLink from "./components/ActiveLink";

export default function NavbarItems({ customer }) {
  return (
    <div className={`hidden lg:block  ${customer ? "mr-28" : ""}`}>
      <FlexSection
        extraClass={"justify-center gap-4 *:text-nowrap  text-sm xl:text-lg "}
      >
        <ActiveLink href="/about">
          <NavLinkWrapper>About Us</NavLinkWrapper>
        </ActiveLink>
        <ActiveLink href="/gallery">
          <NavLinkWrapper>Gallery</NavLinkWrapper>
        </ActiveLink>
        <ActiveLink href="/events">
          <NavLinkWrapper>Events</NavLinkWrapper>
        </ActiveLink>
        <ActiveLink href="/journals">
          <NavLinkWrapper>Journals</NavLinkWrapper>
        </ActiveLink>
        <ActiveLink href="/writeups">
          <NavLinkWrapper>Writeups</NavLinkWrapper>
        </ActiveLink>
        <ActiveLink href="/contactUs">
          <NavLinkWrapper>Contact Us</NavLinkWrapper>
        </ActiveLink>
        <ActiveLink href="/apbc">
          <NavLinkWrapper>APBC</NavLinkWrapper>
        </ActiveLink>
      </FlexSection>
    </div>
  );
}
